export default __webpack_public_path__ + "static/media/slider3.3e2757ec.png";